class TenderTypeController extends AbstractEntityEditController
	@register()
	@inject '$filter',
		'tenderType'
		'MessageTerminal'
		'MessageTypes'
		'TenderTypeRepository'
		'ToastService'
		'parseBool'

	initialize: ->
		@mainCrud.entityType = 'general.tendertype'
		@mainCrud.entityTitle = 'wbo.new.tendertype'
		@mainCrud.isNewEntity = !@tenderType.id?

		if !@mainCrud.isNewEntity
			@tenderType.value = parseInt(@tenderType.value)
			@tenderType.requires_reference = @parseBool(@tenderType.requires_reference)
			@tenderType.show_in_pos = @parseBool(@tenderType.show_in_pos)
			@tenderType.customer_required = @parseBool(@tenderType.customer_required)
			@tenderType.show_customer_order_number = @parseBool(@tenderType.show_customer_order_number)
			@mainCrud.entityTitle = @tenderType.name
		else
			@tenderType =
				show_in_pos: true

	save: ->
		@mainCrud.saving = true

		@TenderTypeRepository
			.save @tenderType, @mainCrud.isNewEntity
			.then (response) =>
				@tenderType = response.data

				@afterSave response, 'payment.miscellaneous.types'
			.catch (result) =>
				@handleErrors result, 'payment.miscellaneous.types'

	delete: ->
		@deleteEntity @TenderTypeRepository, @tenderType, 'payment.miscellaneous.types'
